<template>
  <div>
    <div class="head">
      <img :src="baseUrl + headInfo.iconUrl" alt="">
      <p>{{ headInfo.title }}</p>
      <a class="banner_btn" @click="contactUs">{{ headInfo.remark }} &gt;</a>
    </div>
    <div v-if="menuList.length" class="current_menu">
      <div class="content">
        <el-menu
          :default-active="activeIndex"
          class="head_menu"
          mode="horizontal"
          :ellipsis="false"
          @select="handleSelect"
        >
          <el-menu-item v-for="(item,index) in menuList" :key="item.id" :index="index+''">{{ item.title }}</el-menu-item>
        </el-menu>
        <a class="home" @click="goHome" />
      </div>
    </div>
    <div class="programme">
      <ul v-if="programmerList.length">
        <li v-for="(item,index) in programmerList" :key="index" @click="soluteDetail(item)">
          <img :src="baseUrl + item.iconUrl" alt="">
          <div class="word">
            <p class="title">{{ item.title }}</p>
            <p class="text">{{ item.remark }}</p>
          </div>
        </li>
      </ul>
      <div v-else class="no_info">暂无信息</div>
    </div>
  </div>
</template>
<script>
import { contactUs, goHome } from '@/plugin/operate.js'
import { getMainContent } from '@/plugin/api'
export default {
  data() {
    return {
      activeIndex: '0',
      programmerList: [],
      menuList: [],
      headInfo: {},
      baseUrl: '/website'
    }
  },
  mounted() {
    const params = this.$route.query
    params.tenantId = 'sft'
    this.getMenuList(params)
  },
  methods: {
    contactUs,
    goHome,
    handleSelect(key, keyPath) {
      this.programmerList = this.menuList[key].children
    },
    soluteDetail(item) {
      this.$router.push({
        path: '/soluteDetail',
        query: {
          url: item.url,
          urlType: item.urlType
        }
      })
    },
    getMenuList(params) {
      getMainContent(params).then(res => {
        const mArr = res.data.data.contentMainList[0].contentItemTreeList
        const sArr = res.data.data.contentMainList[0].contentItemTreeList.slice(1)
        this.headInfo = mArr[0]
        this.menuList.push(...sArr)
        this.programmerList = this.menuList[0].children
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu--horizontal{
  border: none;
}
.el-menu-item{
  font-size: 18px;
  padding: 0 30px;
  line-height: 50px;
  background-color: #F5F5F5;
}
.el-menu--horizontal>.el-menu-item:hover{
  border-bottom: 4px solid #00A59E;
  color: #00A59E!important;
  background-color: #F5F5F5;
}
.el-pagination.is-background .btn-next.is-active, .el-pagination.is-background .btn-prev.is-active, .el-pagination.is-background ul.el-pager li.is-active{
  background-color: #00A59E;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  background-color: #F5F5F5;
}
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 4px solid #00A59E;
    color: #00A59E!important;
}
.el-pagination{
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.head{
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
  }
  p{
    color: #fff;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
}
.programme{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ul{
    width: 1400px;
    margin: 50px auto;
    display: flex;
    flex-wrap: wrap;
    li{
      cursor: pointer;
      display: flex;
      border: 1px solid #E8E8E8;
      margin: 0 20px 40px 0;
      &:nth-child(even){
        margin-right: 0;
      }
      img{
        width: 320px;
        height: 190px;
      }
      .word{
        margin: 0 30px;
        .title{
          color: #000000;
          font-size: 18px;
          padding: 8px 0;
          border-bottom: 1px solid #BBBBBB;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .text{
          width: 300px;
          color: #101010;
          font-size: 14px;
          text-align: justify;
          word-break: break-all;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
// 屏幕大于 1024px 或小于 1440px 时应用该样式
@media screen and (max-width: 1440px) {
  .programme{
    ul{
      width: 1200px;
      li{
        margin: 0 15px 40px 0;
        img{
          width: 280px;
        }
        .word{
          margin: 0 20px;
          .text{
            width: 270px;
          }
        }
      }
    }
  }
}
</style>
